import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';
import Button from 'components/Button';

import Main from './MobileVersion.styled';

const MobileVersion = ({ signOut }) => (
  <Main>
    <div className="head">
      <Icon name="logo" />
    </div>
    <div className="body center">
      <img
        src="/assets/img/broken-smartphone.svg"
        alt="broken smartphone"
        width="87px"
      />
      <h2>
        <span>ruttl works only on a</span>
        <br />
        <span className="blue"> desktop/laptop </span>
        <span>browser</span>
      </h2>
      <p>
        We noticed that you were signing up from your mobile device. Please
        access ruttl from a laptop/desktop browser.
      </p>
    </div>
    <div className="footer center">
      <Button type="button" styled onClick={signOut}>
        Logout
      </Button>
    </div>
  </Main>
);

MobileVersion.propTypes = {
  signOut: PropTypes.func.isRequired,
};

export default MobileVersion;
